// This file is adapted from the swiftly-transit-dashboard repo

// Segment's JavaScript library Analytics.js is imported globally and exposed as
// window.analytics. This module is a minimal wrapper around their library. Its
// main benefit is better tooling for our local environment.

let isInitialized = false;
const isSegmentEnabled = window.isSegmentEnabled && window.isSegmentLoading;

const isValidSegmentEnvironment = (fnName) => {
  if (!isSegmentEnabled) {
    return false;
  }

  if (!isInitialized) {
    // TODO: ideally send an error to Sentry: `[Segment] window.analytics.${fnName} called before initialization`
    return false;
  }

  if (window.analytics && typeof window.analytics[fnName] === 'function') {
    return true;
  }

  // TODO: ideally send an error to Sentry: `[Segment] unable to call window.analytics.${fnName}`
  return false;
};

export const segmentTrack = (
  eventName,
  { properties, options, callback } = {},
) => {
  if (isValidSegmentEnvironment('track')) {
    window.analytics.track(eventName, properties, options, callback);
  }
};

export const initializeSegment = () => {
  console.debug('Trying to initialize Segment...');

  if (isSegmentEnabled && window.analytics == null) {
    setTimeout(Segment.initialize, 500);
    return;
  }

  console.debug('Initialized Segment.');
  isInitialized = true;
};
